export default {
  recommendations: state => state.recommendations,
  recommendation: state => state.recommendation,
  step: state => state.step,
  visitedStep: state => state.visitedStep,
  translations: state => state.translations,
  testdriveResultType: state => state.testdriveResultType,
  testdriveResultTypes: state => state.testdriveResultTypes
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/configuration/getters.js